// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 30px;
}

.auth-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

h1 {
  color: #333;
  margin-bottom: 0;
}

.logout-btn {
  background: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
}

.subtitle {
  color: #666;
  margin-bottom: 30px;
}

.event-types {
  display: grid;
  gap: 15px;
}

.event-card {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  text-decoration: none;
  color: inherit;
  display: block;
}

.event-card h3 {
  color: #1C7EBB;
  font-size: 1.1em;
  margin-bottom: 6px;
}

.event-card p {
  color: #666;
  font-size: 0.9em;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/test-events/index/TestEventsIndexCmp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 0 auto;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  padding: 30px;\n}\n\n.auth-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\nh1 {\n  color: #333;\n  margin-bottom: 0;\n}\n\n.logout-btn {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9em;\n}\n\n.subtitle {\n  color: #666;\n  margin-bottom: 30px;\n}\n\n.event-types {\n  display: grid;\n  gap: 15px;\n}\n\n.event-card {\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 20px;\n  text-decoration: none;\n  color: inherit;\n  display: block;\n}\n\n.event-card h3 {\n  color: #1C7EBB;\n  font-size: 1.1em;\n  margin-bottom: 6px;\n}\n\n.event-card p {\n  color: #666;\n  font-size: 0.9em;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
